import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';

/**
 * Style.
 */
import './checkbox.scss';

const Checkbox = ({
  label,
  name,
  white,
  content,
  meta: { touched, error },
  input: { checked, ...input },
}) => (
  <div>
    <label
      className={className(
        'checkbox-wrapper',
        { white },
        { 'has-error': touched && error },
      )}
    >
      {label}
      <input
        name={name}
        {...input}
        checked={input.value === 'S'}
        type="checkbox"
        className="checkbox-input"
      />
      <span className="checkbox-mark" />
    </label>
    { content }
    {touched && error && (
      <div>
        <span className="error-span">{error}</span>
      </div>
    )}
  </div>
);

Checkbox.propTypes = {
  name: PropTypes.any,
  label: PropTypes.any.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  white: PropTypes.bool,
  content: PropTypes.any,
};

Checkbox.defaultProps = {
  meta: {},
  white: false,
  name: PropTypes.any,
  content: null,
};

export default Checkbox;
